import {
  DATA_ROOM_MEMBER_ROLES,
  DataRoomMemberRole,
} from '../models/DataRoomMember';
import { Q_AND_A_ROLES, QAndARoles } from '../models/QAndA';
import { COLOR_VARIANT, ColorVariants } from 'models/Colors';

export const roleTagColorMap: Record<DataRoomMemberRole, ColorVariants> = {
  [DATA_ROOM_MEMBER_ROLES.ADMIN]: COLOR_VARIANT.BLUE,
  [DATA_ROOM_MEMBER_ROLES.OWNER]: COLOR_VARIANT.DARK_GREEN_FULL,
  [DATA_ROOM_MEMBER_ROLES.PUBLISHER]: COLOR_VARIANT.GREEN,
  [DATA_ROOM_MEMBER_ROLES.VIEWER_DOWNLOADER]: COLOR_VARIANT.ORANGE,
  [DATA_ROOM_MEMBER_ROLES.VIEWER]: COLOR_VARIANT.SILVER,
};

export const roleTagLabelMap: Record<DataRoomMemberRole, string> = {
  [DATA_ROOM_MEMBER_ROLES.ADMIN]: 'admin',
  [DATA_ROOM_MEMBER_ROLES.OWNER]: 'owner',
  [DATA_ROOM_MEMBER_ROLES.PUBLISHER]: 'publish',
  [DATA_ROOM_MEMBER_ROLES.VIEWER_DOWNLOADER]: 'download',
  [DATA_ROOM_MEMBER_ROLES.VIEWER]: 'view',
};

export const qaRoleTagColorMap: Record<QAndARoles, ColorVariants> = {
  // sell
  [Q_AND_A_ROLES.OWNER]: COLOR_VARIANT.DARK_GREEN_FULL,
  [Q_AND_A_ROLES.ADMIN_SELL]: COLOR_VARIANT.BLUE,
  [Q_AND_A_ROLES.COORDINATOR]: COLOR_VARIANT.ORANGE,
  [Q_AND_A_ROLES.EXPERT]: COLOR_VARIANT.SILVER,
  [Q_AND_A_ROLES.ANSWER_APPROVER]: COLOR_VARIANT.GREEN,
  // buy
  [Q_AND_A_ROLES.ADMIN_BUY]: COLOR_VARIANT.BLUE,
  [Q_AND_A_ROLES.QUESTION_APPROVER]: COLOR_VARIANT.GREEN,
  [Q_AND_A_ROLES.DRAFTER]: COLOR_VARIANT.SILVER,

  // both
  [Q_AND_A_ROLES.NONE]: COLOR_VARIANT.GREY,
};

export const qaRoleTagLabelMap: Record<QAndARoles, string> = {
  // sell
  [Q_AND_A_ROLES.OWNER]: 'owner',
  [Q_AND_A_ROLES.ADMIN_SELL]: 'admin',
  [Q_AND_A_ROLES.COORDINATOR]: 'coordinate',
  [Q_AND_A_ROLES.EXPERT]: 'expert',
  [Q_AND_A_ROLES.ANSWER_APPROVER]: 'approve',

  // buy
  [Q_AND_A_ROLES.ADMIN_BUY]: 'admin',
  [Q_AND_A_ROLES.QUESTION_APPROVER]: 'approve',
  [Q_AND_A_ROLES.DRAFTER]: 'draft',

  // both
  [Q_AND_A_ROLES.NONE]: 'none',
};
